module.exports = function () {
  return {
    name: "module-federation-configure-remotes",
    beforeInit(args) {
      const { userOptions } = args;
      const { origin: hostUrl } = new URL(document.currentScript.src);

      userOptions.remotes.forEach(remote => {
        remote.entry = `${hostUrl}/${remote.alias}/remoteEntry.js`;
      });

      return args;
    },
  };
};
